export const BASKET_ROOM_UPGRADE_FLAG = 'feature.basket-room-upgrade';

export const UPGRADE_QUERY_PARAM = 'upgrade';
